import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import '../scss/customize.scss';

import Utility from "./class/utility";
import CUSTOMIZE from "./extended_class/customize";
import HOME from "./module/home";
import RECRUIT from "./module/recruit";

// ユーティリティクラスのインスタンス化
const UTIL = new Utility();

// テンプレートインスタンス化（promise登録）
const TPL = new CUSTOMIZE();

// URLによる関数の実行
UTIL.loader( (request, path) => {
  switch( path ){
    case '/': HOME(); break
    case '/recruit/': RECRUIT(); break
  }
  // switch( request ){}
});

if (window.location.hash && window.location.hash !== '#provided' && window.location.hash !== '#control') {
  const cleanURL = window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search;
  window.history.replaceState(null, document.title, cleanURL);
}

document.addEventListener('DOMContentLoaded', () => {
  const bnrWrap = document.querySelector('.fixed-bnr__wrap');
  const bnrClose = document.querySelector('.fixed-bnr__close');

  if (bnrWrap && bnrClose) {
    bnrClose.addEventListener('click', () => {
      bnrWrap.classList.add('is-hidden');
      
      setTimeout(() => {
        bnrWrap.style.display = 'none';
      }, 500);
    });
  }
});


setTimeout(() => {
  const catchElements = document.querySelectorAll('.catch1');
  if (catchElements.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.target.closest('.mainvisual')) return;

      if (entry.isIntersecting) {
        entry.target.classList.add('catch1-active');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0 });

  catchElements.forEach(el => observer.observe(el));
}, 100);